module.exports = __webpack_public_path__ + "static/media/vanity double bowl.a02abe93.jpg";